<template>
  <footer class="footer-container">
    <div class="footer-content">
      <!-- 服务热线区域 -->
      <div class="hotline-section wow fadeInUp">
        <!-- <i class="phone-icon"></i> -->
        <span class="hotline-text iconfont">服务热线</span>
        <div class="phone-number">{{ SpgData.call }}</div>
      </div>
  
      <!-- 导航链接区域 -->
      <div class="nav-section wow fadeInUp">
        <div class="nav-column">
          <h3 class="nav-title">关于我们</h3>
          <ul class="nav-links">
            <li><router-link to="/aboutus/aboutsView">集团介绍</router-link></li>
            <li><router-link to="/aboutus/CorporateCulture">品牌文化</router-link></li>
            <li><router-link to="/NewsView">新闻动态</router-link></li>
          </ul>
        </div>
        
        <div class="nav-column">
          <h3 class="nav-title">旗下产品</h3>
          <ul class="nav-links">
            <li>
              <router-link to="/ProductShowcase" class="special">茶业</router-link>
              <router-link to="/ProductShowcase">茶宴</router-link>
            </li>
            <li>
              <router-link to="/ProductShowcase" class="special">茶饮</router-link>
              <router-link to="/ProductShowcase">茶舱</router-link>
            </li>
            <li><router-link to="/ProductShowcase">茶器</router-link></li>
          </ul>
        </div>
        
        <div class="nav-column">
          <h3 class="nav-title">责任与公益</h3>
          <ul class="nav-links">
            <li><router-link to="/socialResponsibility/PublicWelfareView">公益之行</router-link></li>
            <li><router-link to="/socialResponsibility/PublicWelfareView">社会责任</router-link></li>
          </ul>
        </div>
      </div>
  
      <!-- 社交媒体区域 -->
      <div class="social-section">
        <div class="social-item wow fadeInUp" v-for="(item,index) in SpgData.QRcode" :key="index" :data-wow-delay="index * 0.1 + 's'">
          <div class="social-icon"><img :src="item.img"></div>
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>

    <!-- 版权信息区域 -->
    <div class="copyright-section wow fadeInUp">
      <p>Copyright@三皮罐大健康产业集团<br>{{ SpgData.ICP }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      SpgData:{}
    }
  },
  // 可根据实际需求添加props或methods
  props: {
    // SpgData: {
    //   type: Object,
    //   default() {  // 用函数返回默认对象
    //     return {};
    //   }
    // },
    // 示例：可自定义版权信息
    copyrightText: {
      type: String,
      default: 'Copyright@湖北三皮罐大健康产业集团有限公司'
    },
    icpText: {
      type: String,
      default: '鄂ICP备2025102539号'
    }
  },
  created() {
    this.getSPGData()
  },
  mounted() {
    // 初始化 wow 动画
    this.$wow.init()
  },
  methods: {
    // 请求获取数据信息
    getSPGData() {
      const query = new this.$AV.Query("SPG");
      query.get("688aea9d9bf5cd01d7ae8f8c")
      .then((SpgData) => {
        this.SpgData = JSON.parse(SpgData._hashedJSON.SpgData)
        // this.NewsData = SpgData.attributes.NewsData
        this.$nextTick(() => {
          this.$wow.sync() // 同步新添加的元素
        })
        // this.parentBannerItems = JSON.parse(SpgData._hashedJSON.SpgData).BannerInfo
        // this.PosterInfo = SpgData.attributes.PosterInfo
        console.log(this.SpgData)
      })
      .catch((err) => {
        console.error(err.SpgData)
      });
    }
  }

}
</script>

<style scoped>
.footer-container {
  background-color: #333333;
  color: #ffffff;
  box-sizing: border-box;
  font-size: 0.5rem;
  border-top: 20px solid #e60012;
}
.footer-content {
  padding: 20px;
  margin-bottom: 50px;
}

/* 服务热线样式 */
.hotline-section {
  text-align: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.phone-icon {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'/%3E%3C/svg%3E") no-repeat center;
  background-size: contain;
  vertical-align: middle;
  margin-right: 0.5rem;
}

.hotline-text {
  color: #ffffff;
  font-size: 0.9rem;
}
.hotline-text::before{
  content: "\e84f";
  font-size: 44px;
  vertical-align: middle;
  animation: shake 0.5s ease-in-out infinite;
  display: inline-block;
  white-space: nowrap;
}
@keyframes shake {
0%, 100% {
      transform: rotate(0deg); /* 初始和结束位置 */
}
25% {
      transform: rotate(-8deg); /* 向左旋转5度 */
}
75% {
      transform: rotate(8deg); /* 向右旋转5度 */
}
}
.phone-number {
  color: #ff0000;
  font-size: 1.5rem;
  /* font-weight: bold; */
  margin-top: 0.5rem;
  letter-spacing: 0.05rem;
  font-family: "RAJDHANIB";
}

/* 导航区域样式 */
.nav-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding: 0 20px;
  box-sizing: border-box;
}

.nav-column {
  flex: 1;
  text-align: left;
  white-space: nowrap;
}

.nav-title {
  font-size: .6rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.nav-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-links li {
  margin-bottom: 0.75rem;
  font-size: .5rem;
}

.nav-links a {
  color: #ffffff;
  text-decoration: none;
  opacity: 0.8;
  transition: opacity 0.3s;
}
.nav-links a.special {
  margin-right: 5px;
  border-right: 2px solid #ccc;
  padding-right: 5px;
}

.nav-links a:hover {
  opacity: 1;
  text-decoration: underline;
}

.social-section-before {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  justify-content: center; /* 整体居中 */
  gap: 30px; /* 子元素间距（横纵均20px） */
  padding: 20px; /* 避免边缘贴边 */
  box-sizing: border-box; /* 防止内边距影响整体宽度 */
}

.social-item-before {
  /* 关键调整：使用百分比+最小宽度确保两列 */
  flex: 0 0 calc(50% - 30px); /* 50%宽度减去一半间距（避免溢出） */
  max-width: 200px; /* 最大宽度限制 */
  min-width: 120px; /* 最小宽度（防止过小屏幕挤压变形） */
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box; /* 确保padding/border不影响宽度计算 */
}
.social-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px; 
  margin: 0 auto;
  padding: 0px; 
  box-sizing: border-box;
}

.social-item {
  width: calc(30% - 20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box; /* 确保padding/border不影响宽度计算 */
}


.social-icon {
  width: 100%;
  height: auto;
  margin-bottom: 8px;
}
.social-icon img {
	width: 100%;
	height: auto;
  border-radius: 4px;
}
/* 版权信息样式 */
.copyright-section {
  height: 65px;
  background-color: #e60012;
  text-align: center;
  font-size: .5rem;
  line-height: 24px;
}
.copyright-section p{
  padding-top: 10px;
  line-height: 22px;
}

/* 响应式调整 */
@media (max-width: 375px) {
  .phone-number {
    font-size: 1.25rem;
  }
  
  .social-icon {
    width: 3.5rem;
    height: 3.5rem;
  }
}
</style>
